export default __webpack_public_path__ + "static/media/search-icon.aba00d7e.svg";